import PropTypes from 'prop-types';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { dateTimeIndo } from '../../utilities/helper';

const cardAnnualRecords = ({ user, datas }) => {
    
    const columns = [
        {
            field: 'createdAt',
            headerName: 'Time',
            width: 200,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {dateTimeIndo(params.row.createdAt)}
                    </div>
                )
            } 
        },
        { 
            field: 'last_annual', 
            headerName: 'Cuti Terakhir',
            width: 150, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.last_annual}
                    </div>
                )
            } 
        },
        {
            field: 'new_annual',
            headerName: 'Cuti Terbaru',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.new_annual}
                    </div>
                )
            } 
        },
        {
            field: 'note',
            headerName: 'Note Update Cuti',
            width: 400,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.note}
                    </div>
                )
            } 
        },
    ]

    return (
        <div className={`my-5 flex flex-col lg:flex-row ${user.is_admin === "admin" || user.is_admin === "superadmin" ? "justify-evenly" : "justify-start"} gap-7 md:gap-10`}>
            {/* list data */}
            <div className='w-full h-full flex flex-col gap-3 items-center'>
                <div className="p-2 w-full flex bg-white drop-shadow-lg rounded-md">
                    <DataGrid
                        autoHeight {...datas}
                        rows={datas}
                        columns={columns}
                        pageSize={5}
                        getRowId={(row) => row.id}
                        rowsPerPageOptions={[5]}
                        checkboxSelection
                        disableSelectionOnClick
                        components={{ Toolbar: GridToolbar, }}
                        sortModel={[
                            {
                                field: 'createdAt',
                                sort: 'desc',
                            },
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}

cardAnnualRecords.propTypes = {
    user: PropTypes.object,
    datas: PropTypes.arrayOf(PropTypes.object)
}

export default cardAnnualRecords